import { Card, Typography } from "@mui/material";
import { Detail } from "../types";

export default function ImageBox(props: Detail) {
    return (
        <Card className={"flex flex-col mx-auto mt-5 p-5 w-4/5 lg:w-2/4"}>
            {
                props.title
                &&
                <Typography sx={{ fontSize: 16, marginBottom: 2 }} component="div">
                    <div className="richtext-html" dangerouslySetInnerHTML={{ __html: props.title }} />
                </Typography>
            }
            {
                props.desc
                &&
                <Typography sx={{ fontSize: 16 }} component="div">
                    <div className="richtext-html" dangerouslySetInnerHTML={{ __html: props.desc }} />
                </Typography>
            }
            {
                props.image !== undefined && props.image !== null
                &&
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img src={props.image} style={{ width: 200, height: 200 }} alt="" loading="lazy" className='mt-10 mb-10 self-center' />
                </div>
            }
        </Card>
    )
}